module.exports = __webpack_public_path__ + "static/img/celoscope-detail-12.41f4006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-12.jpg
// module id = PflL
// module chunks = 51